var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePageBigImageFormat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "#6BA5B4",
    transform: "translate(.849)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.333,
    height: 5.333,
    rx: 2.667,
    transform: "translate(38.182 34.667)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.667,
    height: 5.333,
    rx: 2.667,
    transform: "translate(16.849 42.667)",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageBigImageFormat);
export default __webpack_public_path__ + "static/media/HomePageBigImageFormat.5878001d.svg";
export { ForwardRef as ReactComponent };